import { createFileRoute, Navigate, Outlet } from '@tanstack/react-router';
import RecipientsTable from '../../../../Components/RecipientsTable';
import { useFeaturePermissionsLoaded } from '../../../../Selectors/Permission';
import { useCanUseUnosRecipients } from '../../../../Hooks/featurePermission';

export const Route = createFileRoute('/(main)/_layout/candidates/_candidates')({
  component: RouteComponent,
});

function RouteComponent() {
  const featurePermissionsLoaded = useFeaturePermissionsLoaded();
  const canViewUnosRecipients = useCanUseUnosRecipients();

  // Wait for permissions to load before deciding whether to redirect.
  if (!featurePermissionsLoaded) {
    return null;
  }

  if (!canViewUnosRecipients) {
    return <Navigate to="/chats" />;
  }
  return (
    <div>
      <RecipientsTable />
      <Outlet />
    </div>
  );
}
